import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import NewsList from '../components/NewsList';
import InstagramFeed from '../components/InstagramFeed';
import { useCachedTexts } from '../hooks/useCachedTexts';
import './NewsPage.css';

const NewsPage = () => {
  const { t } = useTranslation();
  const { getText } = useCachedTexts('news');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="news-page">
      <SEO 
        title="News & Articles - Communications and PR"
        description="Latest news, articles and insights on communications, PR, media relations and sports communications from Magicomms."
        keywords="communications news, PR articles, media relations, sports communications, press office news"
        lang="it"
      />

      <div className="news-container">
        <h1>{getText('title', t('news.title'))}</h1>
        <p className="news-subtitle">{getText('subtitle', t('news.subtitle'))}</p>
        
        {/* News Articles from Sanity */}
        <section className="news-articles-section">
          <NewsList />
        </section>
      </div>

      {/* Instagram Feed - Full Width */}
      <section className="instagram-section">
        <div className="instagram-section-inner">
          <h2 className="instagram-section-title">{getText('instagram_heading', t('news.followInstagram'))}</h2>
          <InstagramFeed limit={6} columns={3} />
          
          <a 
            href="https://www.instagram.com/magicomms/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="instagram-follow-btn"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            {getText('instagram_button', t('news.followButton'))}
          </a>
        </div>
      </section>
    </div>
  );
};

export default NewsPage;
